const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Disclaimer</h1>
        
        <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Independent Consultancy</h2>
            <p>
              Kiwi Connect Consultants is an independent immigration consultancy service. We are not affiliated with, 
              endorsed by, or officially connected to any government immigration department, embassy, or consulate of 
              any country including but not limited to New Zealand, United Kingdom, Schengen countries, Australia, or Canada.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">No Guarantee of Visa Approval</h2>
            <p>
              <strong>Important:</strong> Kiwi Connect Consultants does not guarantee visa approvals. All visa decisions 
              are made solely and exclusively by the respective immigration authorities of the destination country. 
              Our role is limited to providing guidance, documentation assistance, and application support.
            </p>
            <p>
              Visa approval depends on multiple factors including but not limited to: applicant's profile, documentation quality, 
              immigration policy changes, country-specific requirements, and assessment by immigration officers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Advisory Services</h2>
            <p>
              Our services include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Eligibility assessment and pathway recommendations</li>
              <li>Documentation guidance and review</li>
              <li>Application form assistance</li>
              <li>Process clarification and support</li>
            </ul>
            <p>
              We provide professional advice to the best of our knowledge based on current immigration policies. 
              However, immigration laws and policies are subject to change without notice, and we cannot be held 
              responsible for changes implemented by government authorities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Client Responsibility</h2>
            <p>
              Clients are responsible for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Providing accurate, complete, and truthful information</li>
              <li>Submitting genuine and authentic documents</li>
              <li>Meeting all requirements set by immigration authorities</li>
              <li>Complying with visa conditions if approved</li>
              <li>Understanding that misrepresentation can lead to visa refusal and future bans</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Limitation of Liability</h2>
            <p>
              Kiwi Connect Consultants shall not be held liable for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Visa refusals or rejections by immigration authorities</li>
              <li>Delays in visa processing by government departments</li>
              <li>Changes in immigration policies or requirements</li>
              <li>Consequences arising from client's false or incomplete information</li>
              <li>Actions or decisions made by immigration officers or authorities</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Ethical Practice</h2>
            <p>
              Kiwi Connect Consultants is committed to ethical immigration consulting practices. We:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Do not make false promises or guarantees</li>
              <li>Do not engage in document fabrication or misrepresentation</li>
              <li>Provide honest assessment of client eligibility</li>
              <li>Operate with transparency and integrity</li>
              <li>Maintain client confidentiality</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Refund Policy</h2>
            <p>
              Service fees paid to Kiwi Connect Consultants are for professional consultation and application assistance. 
              These fees are non-refundable regardless of visa outcome, as they compensate for time, expertise, and 
              services rendered. Refund terms, if any, will be clearly specified in individual service agreements.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Website Information</h2>
            <p>
              Information provided on this website is for general guidance only and should not be considered legal advice. 
              While we strive to keep information accurate and updated, immigration policies change frequently. 
              Clients are advised to verify current requirements with official government sources.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Acceptance of Terms</h2>
            <p>
              By engaging our services or using this website, you acknowledge that you have read, understood, and 
              agree to this disclaimer and all terms stated herein.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact for Clarifications</h2>
            <p>
              For any clarifications regarding this disclaimer, please contact:
            </p>
            <p className="font-medium">
              Email: info@kiwiconnectconsultants.com<br />
              Phone: +91 9998581146 | +91 7990039645 | +64 221601146
            </p>
          </section>

          <p className="text-sm text-gray-600 mt-8 pt-6 border-t">
            Last Updated: December 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
